<template>
  <div>
    <b-table-lite striped hover :items="items" :fields="visibleFields" caption-top thead-class="hidden_header" responsive="md" @row-clicked="rowClicked">
      <template slot="table-caption">
        <b-row>
          <b-col>
            <b-button-toolbar>
              <b-button-group v-if="!settings.hideNew && settings.newUrl && typeof(settings.newUrl) !== 'function'">
                <b-button :to="settings.newUrl"><font-awesome-icon icon="plus"></font-awesome-icon> New</b-button>
              </b-button-group>
              <b-button-group v-if="!settings.hideNew && settings.newUrl && typeof(settings.newUrl) === 'function'">
                <b-button :to="settings.newUrl()"><font-awesome-icon icon="plus"></font-awesome-icon> New</b-button>
              </b-button-group>
              <slot name="toolbar-buttons">
              </slot>
              <b-button-group class="mx-2">
                <b-dropdown>
                  <template slot="button-content">
                    <font-awesome-icon icon="table" />
                  </template>
                  <b-dropdown-item-button v-for="column in settings.columns" v-bind:key="column.key" v-on:click="toggleColumn(column)">
                    <font-awesome-icon icon="square" v-if="!column.visible" />
                    <font-awesome-icon icon="check-square" v-if="column.visible" />
                    {{column.name}}
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown :text="limit.toString()" v-if="settings.query">
                  <b-dropdown-item-button v-for="limit in limits" v-bind:key="limit" v-on:click="setLimit(limit)">{{limit}}</b-dropdown-item-button>
                </b-dropdown>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
          <b-col class="text-right">
            <span v-if="settings.query && total > 0">
              {{page * limit - limit + 1}}-{{page * limit > total ? total : page * limit}} of {{total}} results
            </span>
            <span v-if="settings.query && total == 0">
              No results
            </span>
          </b-col>
        </b-row>
      </template>
      <template slot="thead-top">
        <tr>
          <th v-for="column in visibleColumns" v-bind:key="column.key" v-on:click="setSortColumn(column)">
            {{column.name}}
            <span v-if="column.key == sortColumn">
              <font-awesome-icon :icon="sortOrder == 'asc' ? 'sort-amount-down' : 'sort-amount-up'" />
            </span>
          </th>
        </tr>
        <tr>
          <th v-for="column in visibleColumns" v-bind:key="column.key">
            <b-form-input v-model="filters[column.key]" v-if="column.filter == 'text'" @keyup="refreshData(true)"></b-form-input>
            <b-form-input v-model="filters[column.key]" v-if="column.filter == 'date'" type="date" @change="refreshData(true)"></b-form-input>
            <b-row v-if="column.filter == 'daterange'">
              <b-col xs="12" md="6">
                <b-form-input v-model="filters[column.key].low" v-if="column.filter == 'daterange'" type="date" @change="refreshData(true)"></b-form-input>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-input v-model="filters[column.key].high" v-if="column.filter == 'daterange'" type="date" @change="refreshData(true)"></b-form-input>
              </b-col>
            </b-row>
            <b-form-select v-model="filters[column.key]" v-if="column.filter == 'select'" :options="column.selectOptions" @change="refreshData()"></b-form-select>
          </th>
        </tr>
      </template>
      <template v-slot:cell()="data">
        <slot :name="data.field.key" v-bind:item="rawItems[data.index]">
          {{data.value}}
        </slot>
      </template>
      <template slot="actions" slot-scope="data">
        <b-button-group>
          <b-button variant="default" v-for="action in data.value.actions" v-bind:key="action.key">
            <router-link :to="action.getUrl(rawItems[data.index])"><font-awesome-icon :icon="action.icon" /></router-link>
          </b-button>
        </b-button-group>
      </template>
    </b-table-lite>
    <span v-if="settings.query && total > 0">
      {{page * limit - limit + 1}}-{{page * limit > total ? total : page * limit}} of {{total}} results
    </span>
    <span v-if="settings.query && total == 0">
      No results
    </span>
    <span v-if="!settings.query && items.length == 0">
      <div>
        No results
      </div>
      <div>
        <b-button variant="secondary" @click="clearFilters">Clear Filters</b-button>
      </div>
    </span>
    <b-pagination v-if="settings.query" v-model="page" :total-rows="total" :per-page="limit" @input="refreshData"></b-pagination>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FilteredTable",
  props: [
    'settings',
    'staticItems'
  ],
  data() {
    return {
      limit: 10,
      limits: [1, 2, 5, 10, 25, 50, 100],
      filters: this.getDefaultSettings(),
      rawItems: [],
      items: [],
      total: 0,
      page: 1,
      sortColumn: null,
      sortOrder: 'asc',
      refreshDataTimeout: null
    }
  },
  computed: {
    visibleColumns: function () {
      return this.settings.columns.filter(c => c.visible);
    },
    visibleFields: function () {
      return this.settings.columns.filter(c => c.visible && !c.key.startsWith('_')).map(c => c.key);
    }
  },
  methods: {
    getDefaultSettings: function () {
      let retVal = [];
      this.settings.columns.forEach(f => {
        if (f.filter == 'daterange') {
          retVal[f.key] = {
            low: null,
            high: null
          }
        } else {
          retVal[f.key] = null;
        }
      });
      return retVal;
    },
    rowClicked: function (item, index, event) {
      if (!this.settings.rowClicked)
        return;
      let rawItem = this.rawItems[index];
      this.settings.rowClicked(rawItem, this);
    },
    toggleColumn: function (column) {
      column.visible = !column.visible;
      this.refreshData();
    },
    setLimit: function (newLimit) {
      this.limit = newLimit;
      this.refreshData();
    },
    setSortColumn: function (column) {
      if (!column.sortable)
        return;

      if (this.sortColumn == column.key)
        this.sortOrder = this.sortOrder == 'asc' ? 'desc' : 'asc';
      else {
        this.sortColumn = column.key;
        this.sortOrder = 'asc';
      }

      this.refreshData();
    },
    clearFilters: function () {
      this.filters = this.getDefaultSettings();
      this.refreshData();
    },
    refreshItems: function () {
      // Recreates items from rawItems - doesn't actually go back to server for different data
      this.items = [];
      if (this.rawItems) {
        this.rawItems.forEach(row => {
          let item = {};
          this.settings.columns.forEach(col => {
            if (col.visible) {
              if (col.key == 'actions')
                item[col.key] = col;
              else {
                let p = col.key.split('.');
                let v = row;
                p.forEach(k => {
                  if (v)
                    v = v[k];
                });

                if (col.render)
                  item[col.key] = col.render(v);
                else if (col.filter == 'select') {
                  let selectItem = col.selectOptions.find(c => c.value == v);
                  if (selectItem)
                    item[col.key] = selectItem.text;
                }
                else
                  item[col.key] = v;
              }
            }
          });

          this.items.push(item);
        });
      }
    },
    refreshData: function () {
      if (this.settings.query)
        this.refreshDataAjax();
      else
        this.refreshDataStatic();
    },
    refreshDataStatic: function () {
      let tempItems = this.staticItems;

      this.settings.columns.forEach(col => {
        let f = this.filters[col.key];
        if (f && f.length > 0) {
          if (col.filter == 'text')
            tempItems = tempItems.filter(x => this.getItemValueOrEmpty(x, col.key).toLowerCase().includes(f.toLowerCase()));
          else if (col.filter == 'select') {
            let selectOption = col.selectOptions.find(s => s.value == f);
            if (selectOption.filter)
              tempItems = tempItems.filter(x => selectOption.filter(x));
            else
              tempItems = tempItems.filter(x => this.getItemValueOrEmpty(x, col.key) == f);
          }
        }
      });      

      if (this.sortColumn) {
        tempItems.sort((a, b) => {
          let va = this.getItemValueOrEmpty(a, this.sortColumn);
          let vb = this.getItemValueOrEmpty(b, this.sortColumn);

          if (this.sortOrder == 'desc')
            return vb.localeCompare(va);
          else
            return va.localeCompare(vb);
        });
      }

      this.rawItems = tempItems;
      this.total = this.staticItems.length;
      this.refreshItems();
    },
    getItemValue: function (item, key) {
      let objs = key.split('.');
      let v = item;
      for (let i = 0; i < objs.length; ++i)
        v = v[objs[i]];

      return v;
    },
    getItemValueOrEmpty: function (item, key) {
      let v = this.getItemValue(item, key);
      return v ? v : '';
    },
    refreshDataAjax: function (wait) {
      if (wait) {
        if (this.refreshDataTimeout != null)
          clearTimeout(this.refreshDataTimeout);

        this.refreshDataTimeout = setTimeout(() => {
          this.refreshData();
        }, 250);
        return;
      } else {
        this.refreshDataTimeout = null;
      }

      let offset = (this.page * this.limit) - this.limit;
      let order = null;
      if (this.sortColumn)
        order = this.sortColumn + ' ' + this.sortOrder;

      let filters = [];
      if (this.settings.getDefaultFilter) {
        let defaultFilter = this.settings.getDefaultFilter();
        if (defaultFilter)
          filters.push(defaultFilter);
      }

      this.settings.columns.forEach(col => {
        let f = this.filters[col.key];
        if (f && f.length > 0) {
          if (col.filter == 'text')
            //filters.push('DbFunctionsExtensions.Like(EF.Functions, ' + col.key +', "%' + f + '%")');
            filters.push(col.key + '.Contains("' + f + '")');
          else if (col.filter == 'select')
            // GraphQL uses snake-casing for enums, but our underlying enums are Pascal-cased, so we remove all underscores
            filters.push(col.key + '="' + f.replace(new RegExp('_', 'g'), "") + '"');
          else if (col.filter == 'date')
            filters.push(col.key + '="' + f + '"');
        }
        if (f && col.filter == 'daterange') {
          if (f.low)
            filters.push(col.key + ' >= "' + f.low + '"');
          if (f.high)
            filters.push(col.key + ' < "' + f.high + '"');
        }
      });

      let filter = filters.join(' AND ');

      let columns = [];
      this.settings.columns.forEach(col=> {
        if ((col.visible || col.alwaysLoad) && !col.static) {
          let objects = col.key.split('.');
          let key = '';
          for (let i = 0; i < objects.length - 1; ++i)
            key += objects[i] + ' { ';
          key += objects[objects.length - 1];
          for (let i = 0; i < objects.length - 1; ++i)
            key += ' } ';

          columns.push(key);
        }
      });
        
      axios
        .post('/graphql/management', {
          query: `
            query Query ($offset: Int, $limit: Int, $order: String, $filter: String) {
              ` + this.settings.query + `Count (filter: $filter),
              ` + this.settings.query + ` (offset: $offset, limit: $limit, order: $order, filter: $filter) {
              ` + columns.join(',') + `
              }
            }`,
          variables: {
            'offset': offset,
            'limit': this.limit,
            'order': order,
            'filter': filter
          }
        })
        .then(response => {
          //console.log(response);

          // TODO: Check for 200?

          this.rawItems = response.data.data[this.settings.query];
          this.total = response.data.data[this.settings.query + 'Count'];
          this.refreshItems();
        })
        .catch(error => {
          console.log(error);
        });      
    }
  },
  mounted () {
    if (this.settings.defaultSortColumn)
      this.sortColumn = this.settings.defaultSortColumn;
    if (this.settings.defaultSortOrder)
      this.sortOrder = this.settings.defaultSortOrder;
    
    this.refreshData();
  },
  activated () {
    this.refreshData();
  }
};
</script>